import { render, staticRenderFns } from "./insuranceDetail.vue?vue&type=template&id=96ce4f8c&scoped=true&"
import script from "./insuranceDetail.vue?vue&type=script&lang=js&"
export * from "./insuranceDetail.vue?vue&type=script&lang=js&"
import style0 from "./insuranceDetail.vue?vue&type=style&index=0&id=96ce4f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce4f8c",
  null
  
)

export default component.exports